export const getLocation = () => {
    ;(window as any)?.appInterface?.getLocation()
}

export const openDatePickerDayMonthYear = (initalDate = null as null | string) => {
    // format - "YYYY-MM-dd"
    ;(window as any)?.appInterface?.openDatePickerDayMonthYear(initalDate)
}

export const openDatePickerMonthYear = (
    initalDate = null as null | string,
    title = ""
) => {
    // format - "YYYY-MM-dd"
    ;(window as any)?.appInterface?.openDatePickerMonthYear(initalDate, title)
}

export const getProfileImage = (
    cameraTitle?: string | null,
    galleryTitle?: string | null,
    isCancellable?: boolean
) => {
    ;(window as any)?.appInterface?.getProfileImage(
        cameraTitle,
        galleryTitle,
        isCancellable
    )
}

export const trackAnalyticsEvent = (
    eventName: string,
    propsMap: any,
    analyticsTypes: Array<string>
) => {
    // analytics options - "FIREBASE", "MIXPANEL", "CLEVERTAP", "BRANCH"
    ;(window as any)?.appInterface?.trackAnalyticsEvent(
        eventName,
        JSON.stringify(propsMap),
        analyticsTypes
    )
}

export const setAnalyticsUserProperty = (
    propsMap: any,
    analyticsTypes: Array<string>
) => {
    // analytics options - "FIREBASE", "MIXPANEL", "CLEVERTAP", "BRANCH"
    ;(window as any)?.appInterface?.setAnalyticsUserProperty(
        JSON.stringify(propsMap),
        analyticsTypes
    )
}

export const finishOnboarding = () => {
    ;(window as any)?.appInterface?.finishOnBoarding()
}

export const finishWebView = (key?: string) => {
    //Exposing this method in case if you want to quit the onBaording at any moment.
    //It will simply dismiss webview container/screen
    ;(window as any)?.appInterface?.finishWebView(key)
}

export const setPrefsLong = (key: string, value: number) => {
    return (window as any)?.appInterface?.setPrefsLong(key, value)
}

export const getPrefsLong = (key: string) => {
    return (window as any)?.appInterface?.getPrefsLong(key)
}

export const setPrefsDouble = (key: string, value: number) => {
    return (window as any)?.appInterface?.setPrefsDouble(key, value)
}

export const getPrefsDouble = (key: string) => {
    return (window as any)?.appInterface?.getPrefsDouble(key)
}

export const setPrefsInt = (key: string, value: number) => {
    return (window as any)?.appInterface?.setPrefsInt(key, value)
}

export const getPrefsInt = (key: string) => {
    return (window as any)?.appInterface?.getPrefsInt(key)
}

export const setPrefsString = (key: string, value: number) => {
    return (window as any)?.appInterface?.setPrefsString(key, value)
}

export const getPrefsString = (key: string) => {
    return (window as any)?.appInterface?.getPrefsString(key)
}

export const setPrefsBoolean = (key: string, value: number) => {
    return (window as any)?.appInterface?.setPrefsBoolean(key, value)
}

export const getPrefsBoolean = (key: string) => {
    return (window as any)?.appInterface?.getPrefsBoolean(key)
}

export const getRemoteConfigString = (key: string) => {
    return (window as any)?.appInterface?.getRemoteConfigString(key)
}

export const getRemoteConfigBoolean = (key: string) => {
    return (window as any)?.appInterface?.getRemoteConfigBoolean(key)
}

export const getRemoteConfigDouble = (key: string) => {
    return (window as any)?.appInterface?.getRemoteConfigDouble(key)
}

export const getRemoteConfigLong = (key: string) => {
    return (window as any)?.appInterface?.getRemoteConfigLong(key)
}
export const refreshToken = (key: string) => {
    return (window as any)?.appInterface?.refreshToken(key)
}
export const showProgressBar = () => {
    ;(window as any)?.appInterface?.showProgressBar()
}
export const hideProgressBar = () => {
    ;(window as any)?.appInterface?.hideProgressBar()
}
export const showExitBottomSheet = (key: ExitBottomSheetStringType) => {
    return (window as any)?.appInterface?.showExitBottomSheet(key)
}
export const getInvocationSource = (key: string) => {
    return (window as any)?.appInterface?.getInvocationSource(key)
}
export const pickImageFromCamera = (enableUCrop: boolean) => {
    return (window as any)?.appInterface?.pickImageFromCamera(enableUCrop)
}
export const pickImageFromGallery = (enableUCrop: boolean) => {
    return (window as any)?.appInterface?.pickImageFromGallery(enableUCrop)
}

type UserData = {
    accessToken: string
    id: string
    language: string
}
type ExitBottomSheetStringType = {
    type: "exit"
    entity: "vas-webview"
    flowType: "vas" | "enrichment"
    title: string
    description: string
    positiveCTAText: string
    negativeCTAText: string
}
export const getUserData = () => {
    if ((window as any).appInterface?.getUser) {
        const userData = (window as any)?.appInterface?.getUser()
        return JSON.parse(userData) as UserData
    }
    return {} as UserData
}
